import { render, staticRenderFns } from "./add-to-cart.vue?vue&type=template&id=aa20e988&"
import script from "./add-to-cart.vue?vue&type=script&lang=js&"
export * from "./add-to-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa20e988')) {
      api.createRecord('aa20e988', component.options)
    } else {
      api.reload('aa20e988', component.options)
    }
    module.hot.accept("./add-to-cart.vue?vue&type=template&id=aa20e988&", function () {
      api.rerender('aa20e988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/add-to-cart/add-to-cart.vue"
export default component.exports